<div class="self-disclosure-person__content">
  <form [formGroup]="form()">
    <div class="d-flex flex-row mb10" [class.mt10]="showRemove()">
      <span>{{ this.title() | translate }}</span>
      @if (showRemove()) {
        <div class="remove-attachment-button">
          <svg-icon
            src="/assets/images/icons/icon-bin.svg"
            [applyClass]="true"
            [svgStyle]="{ 'width.px': 15 }"
            class="secondary-svg-color path rect"
            (click)="removeHandler()"
          ></svg-icon>
        </div>
      }
    </div>

    <div [formGroup]="getAnswerFormControl">
      <div class="row">
        <div class="col-6">
          <app-form-field>
            <app-form-field-label>{{
              'general.first_name_l' | translate
            }}</app-form-field-label>
            <input
              appInput
              type="text"
              [placeholder]="'forms.type_firstname' | translate"
              formControlName="firstName"
              [required]="selfDisclosureQuestion().mandatory"
              class="form-control"
            />
          </app-form-field>
        </div>
        <div class="col-6">
          <app-form-field>
            <app-form-field-label>{{
              'general.last_name_l' | translate
            }}</app-form-field-label>
            <input
              appInput
              type="text"
              [required]="selfDisclosureQuestion().mandatory"
              [placeholder]="'forms.type_lastname' | translate"
              formControlName="lastName"
              class="form-control"
            />
          </app-form-field>
        </div>
      </div>
      @if (showBirthdate()) {
        <div class="row">
          <div class="col-6">
            <app-form-field>
              <app-form-field-label>
                {{ 'general.birthdate_l' | translate }}
              </app-form-field-label>
              <app-date
                [required]="selfDisclosureQuestion().mandatory"
                formControlName="birthDate"
                [startDate]="startDateStruct"
                [maxDate]="maxDateStruct"
                [minDate]="minDateStruct"
              ></app-date>
            </app-form-field>
          </div>
        </div>
      }
    </div>
    @for (
      subQuestionForm of getSubQuestionsFormArray?.controls;
      track subQuestionForm;
      let sqIndex = $index
    ) {
      @let sq = selfDisclosureQuestion().subQuestions[sqIndex];
      @if (isBirthYearSubQuestion(sq)) {
        <div [formGroup]="subQuestionForm" class="row mt20">
          <div class="col-6">
            <im-form-field>
              <label class="im:floating-label">
                <span floatingLabel>{{ sq.title | translate }}</span>
                <input
                  class="im:input"
                  type="text"
                  inputmode="numeric"
                  maxlength="4"
                  [required]="sq.mandatory"
                  [placeholder]="
                    'self_disclosure.answer.child_birth_year_placeholder'
                      | translate
                  "
                  formControlName="answer"
                />
              </label>
            </im-form-field>
          </div>
        </div>
      }
    }
  </form>
</div>
